import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { KVPrimitive, RolodexEntryPatchJson } from 'types'

import { KVMessageDef } from './index'

export function getPrimitiveUpdatedMessage() {
  return {
    type: 'primitiveUpdated',
    requiredData: ['primitiveId', 'transform'],
    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!kv.primitives) return

      const primitiveId = json.primitiveId as string
      const existingIndex = kv.primitives.findIndex((p) => p.id === primitiveId)

      if (existingIndex === -1) {
        console.warn(`PrimitiveUpdated: Primitive ${primitiveId} not found`)
        return
      }

      // Preserve prototype chain (KVPrimitive class) for instanceof checks in MarkupPopupMenu
      // regular spreading would cause the MarkupPopupMenu checks to fail and not open for primis
      const updatedPrimitives = kv.primitives.map((p) => {
        if (p.id === primitiveId) {
          const updated = Object.assign(
            Object.create(Object.getPrototypeOf(p)),
            p,
            {
              transform: json.transform as typeof p.transform,
            }
          )
          return updated
        }
        return p
      })

      kv.setPrimitives(updatedPrimitives)

      if (kv.kestrelModel?.id) {
        const patchData: RolodexEntryPatchJson = {
          id: kv.kestrelModel.id,
          data: {
            primitives: updatedPrimitives.map((p) => KVPrimitive.toJSON(p)),
          },
        }
        kv.rolodexPatch([patchData]).catch((error) => {
          console.error('Failed to save primitive position:', error)
        })
      }
    },
  } as KVMessageDef
}
